import { ActionReducer, MetaReducer } from '@ngrx/store';

export function sessionStorageMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        // Al inicializar, si el estado es undefined, intenta cargar el estado desde sessionStorage
        if (state === undefined) {
            const storedState = sessionStorage.getItem('state');
            if (storedState) {
                return JSON.parse(storedState);
            }
        }
        // Procesa la acción y obtiene el siguiente estado
        const nextState = reducer(state, action);
        // Guarda el siguiente estado en sessionStorage
        sessionStorage.setItem('state', JSON.stringify(nextState));
        return nextState;
    };
}

export const metaReducers: MetaReducer<any>[] = [sessionStorageMetaReducer];